if (window && window.__webpack_asset_path) { //eslint-disable-line
    __webpack_public_path__ = window['__webpack_asset_path']; //eslint-disable-line
}

import React from 'react';
import ReactDOM from 'react-dom';
import root from 'window-or-global';
import {BrowserRouter} from 'react-router-dom';
import { Provider } from 'react-redux';
import { fromJS } from 'immutable';
import { setLocale } from 'epic-common/src/locale';
import ScrollToTopOnUpdate from 'epic-react-common/src/components/ScrollToTopOnUpdate';
import { configureStore } from './configureStore';
import './external/Formsy';
import App from './App';


let initialState = fromJS({});
if (root.__epic_client_state) {
    setLocale(root.__locale);
    initialState = fromJS(root.__epic_client_state);
}
const store = configureStore(initialState);

ReactDOM.hydrate((
    <BrowserRouter>
        <Provider store={store}>
            <ScrollToTopOnUpdate>
                <App />
            </ScrollToTopOnUpdate>
        </Provider>
    </BrowserRouter>
), document.getElementById('bodyWrapper'));
